import styled from "@emotion/styled";
import { generateEditorContentStyle } from "./TextEditor/generate-editor-content-style";

export const Container = styled.div<{ $isEditing: boolean }>`
  position: relative;
  border-radius: 0.5rem;
  padding: 3rem 2rem;
  padding-top: ${(p) => (p.$isEditing ? "4rem" : "3rem")};

  &.section-edit-wrapper {
    .top-bar-container {
      opacity: ${(p) => (p.$isEditing ? 1 : 0)};
      transition: opacity 0.2s ease-in-out;
    }

    &:hover .top-bar-container {
      opacity: 1;
    }
  }
`;

export const FreeTextHtmlContent = styled.div`
  width: 100%;
  max-width: 570px;
  margin: 0 auto;
  padding: 0 1.5rem;

  ${({ theme }) => generateEditorContentStyle(theme)}
`;

export const TextContentContainer = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  transform: scale(1.2);
`;

export const TopBarContainer = styled.div<{ $isEditing: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: ${(p) => (p.$isEditing ? "1.5rem" : "-0.5rem")};
  left: 2rem;
  right: 2rem;
  padding: 0 0.5rem 0 0.5rem;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
